import React, { useState, useEffect } from "react";
import { Card, Form, Button, InputGroup } from "react-bootstrap";
import { getPointsSettings, createPointsSettings } from "../../../services/pointsService";
import { PointsSettings } from "../../../models/PointsSettings";
import UserPointsList from "../UserPointsList";
import { FaUsers } from "react-icons/fa";

const GestionPoints: React.FC = () => {
  const [multiplier, setMultiplier] = useState<number>(2);
  const [pointValue, setPointValue] = useState<number>(0.015);
  const [saved, setSaved] = useState<PointsSettings | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    console.log("[GestionPoints] Chargement des paramètres points depuis l'API...");
    getPointsSettings()
      .then((data) => {
        console.log("[GestionPoints] Données reçues de l'API :", data);
        setMultiplier(data.multiplier);
        setPointValue(data.point_value);
      })
      .catch((error) => console.error("[GestionPoints] Erreur lors du chargement :", error));
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("[GestionPoints] Tentative de sauvegarde :", { multiplier, pointValue });
    setIsSaving(true);
    try {
      const updatedSettings = await createPointsSettings(multiplier, pointValue);
      console.log("[GestionPoints] Réponse après sauvegarde :", updatedSettings);
      setSaved(updatedSettings);
    } catch (error) {
      console.error("[GestionPoints] Erreur lors de la sauvegarde :", error);
    } finally {
      setIsSaving(false);
      console.log("[GestionPoints] Sauvegarde terminée");
    }
  };

  return (
    <>
      <Card
        className="gestion-points-card mb-4 shadow rounded-3 p-4"
        style={{ backgroundColor: "#f9f9f9" }}
      >
        <Card.Body>
          <Card.Title className="d-flex align-items-center flex-wrap gap-2">
            <h2 className="gc-user-page-title" style={{ color: "#2a919d", margin: 0 }}>
              <FaUsers className="me-2 gc-user-header-icon" /> Gestion des Points
            </h2>
            <p className="gc-user-page-subtitle" style={{ color: "#2a919d" }}>
              Définissez le coefficient de calcul et la valeur d'un point attribué aux utilisateurs.
            </p>
          </Card.Title>

          <UserPointsList />

          <Form onSubmit={handleSubmit} className="mb-3">
            <Form.Group className="mb-3 mt-3">
              <Form.Label>Coefficient de calcul des points</Form.Label>
              <InputGroup>
                <Form.Control
                  type="number"
                  min={0}
                  step={0.01}
                  value={multiplier}
                  onChange={(e) => setMultiplier(Number(e.target.value))}
                  required
                  style={{ borderRadius: "0.5rem", borderColor: "#4BB0C0" }}
                />
                <InputGroup.Text style={{ borderRadius: "0.5rem" }}>x montant (€)</InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Valeur d'un point (€)</Form.Label>
              <InputGroup>
                <Form.Control
                  type="number"
                  min={0}
                  step={0.001}
                  value={pointValue}
                  onChange={(e) => setPointValue(Number(e.target.value))}
                  required
                  style={{ borderRadius: "0.5rem", borderColor: "#4BB0C0" }}
                />
                <InputGroup.Text style={{ borderRadius: "0.5rem" }}>€/point</InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <Button
              type="submit"
              disabled={isSaving}
              style={{
                background: "#2A919D",
                border: "none",
                borderRadius: "0.5rem",
                padding: "0.6rem 1.2rem",
                fontWeight: 500,
                width: "100%",
              }}
            >
              {isSaving ? "Sauvegarde..." : "Enregistrer"}
            </Button>
          </Form>

          {saved && (
            <div
              className="alert alert-success p-3 mt-3 rounded-3"
              style={{ backgroundColor: "#d4edda", color: "#55d6d6ff" }}
            >
              Coefficient enregistré : <b>{saved.multiplier}</b> &nbsp;|&nbsp; Valeur du point :{" "}
              <b>{saved.point_value} €</b>
            </div>
          )}
        </Card.Body>

        <style>{`
        @media (max-width: 576px) {
          .gestion-points-card .input-group {
            flex-direction: column;
          }
          .gestion-points-card .input-group > * {
            width: 100% !important;
            margin-bottom: 0.5rem;
          }
        }
      `}</style>
      </Card>

    </>
  );
};

export default GestionPoints;
